import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';

import { ArtigoService } from '../../services/artigo.service';
import { Artigo } from '../../classes/artigo';
import { environment } from '../../environments/environment';
import { TourService } from 'src/services/tour.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  standalone: false,
})
export class ArticleComponent {
  private endpoint = environment.urlFeedback;
  private modal;
  private modalTitle;
  private modalText;
  private modalBtn;
  private modalBackdrop;
  tourId;
  tour;
  articleNotFound = false;
  tourSequence = true;
  helpful = true;
  checkPrecisaMaisInformacoes;
  checkConteudoIncompleto;
  checkLinkAusnete;
  checkDificilEntender;
  hideh2 = true;
  hideaside = false;
  name: string;
  tag: string;
  artigo: Artigo = {
    id: 0,
    titulo: '',
    conteudo: '',
    resumo: '',
    META: { titulo: '', descricao: '' },
    categoria: '',
    idioma: '',
    marcadores: [],
    data_criacao: '',
    data_atualizacao: '',
    relacionados: [],
  };
  pageHeader = {
    title: '',
    style: 'paddingHeader',
  };
  captcha = '';
  isLoading = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private artigoService: ArtigoService,
    private actRoute: ActivatedRoute,
    private http: HttpClient,
    private tourService: TourService,
    private viewportScroller: ViewportScroller,
  ) {
      this.actRoute.paramMap.subscribe((params) => {
      this.isLoading = true;
      this.name = params.get('name');
      this.tag = params.get('tag');
      this.iniciaComponente();
    });
  }

  private iniciaComponente(): void{
    const path = this.activatedRoute.routeConfig?.path;
    if (path?.startsWith('tour/')) {
      this.tourId = this.activatedRoute.snapshot.params['id'];
      this.tourId = this.tourId?.split('-')[0];
      this.getArtigo(false);
      this.getTour(this.tourId);
      this.tourSequence = true;
    } else if (path?.startsWith('category/')) {
      this.getArtigo(true);
      this.tourSequence = false;
    }
    this.modal = document.getElementById('myModal');
    this.modalTitle = document.getElementById('modal_title');
    this.modalText = document.getElementById('modal_text');
    this.modalBtn = document.getElementById('modal_btn');
    this.modalBackdrop = document.getElementById('modal_backdrop');
    setTimeout(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    }, 0);
  }

  private setupCodeBlocks(): void {
    const preElements = document.querySelectorAll('pre[data-code-brush]') as NodeListOf<HTMLElement>;

    preElements.forEach((element) => {
      element.addEventListener('click', (e: MouseEvent) => {
        this.copyForClipboard(e, element);
        preElements.forEach((r) => {
          r.style.setProperty('--pseudo-text', `"Copiado!"`);
          r.style.setProperty('--pseudo-background-color', '#f25946');
          r.style.setProperty('--pseudo-color', 'white');
        });
      });
    });
  }

  getArtigo(contabilizar: boolean): void {
    this.artigoService.getArtigo(this.name, contabilizar).subscribe({
      next: (res) => {
        this.artigo = res;
        this.isLoading = false;
        setTimeout(() => this.setupCodeBlocks(), 0);
      },
      error: () => {
        this.isLoading = false;
        this.notFound();
      },
    });
  }

  getTour(id: number): void {
    this.tourService.getTour(id).subscribe((res) => {
      this.tour = res;
    });
  }

  notFound() {
    this.hideh2 = false;
    this.hideaside = true;
    this.artigo.titulo = '';
    this.artigo.conteudo = '';
    this.articleNotFound = true;
  }

  submeterFeedback(data, validEmail) {
    if (validEmail && data.description != '' && this.captcha != '') {
      this.captcha = '';
      return this.http
        .post(
          this.endpoint,
          JSON.stringify({
            article: this.name,
            email: data.email,
            helpful: data.helpful,
            description: data.description,
            reasons: [
              data.checkPrecisaMaisInformacoes,
              data.checkConteudoIncompleto,
              data.checkLinkAusnete,
              data.checkDificilEntender,
            ],
          }),
          {
            observe: 'response',
          }
        )
        .subscribe({
          next: () => {
            this.modalTitle.textContent = 'Sucesso!';
            this.modalText.textContent =
              'O envio de seu feedback foi realizado com sucesso!';
            this.modalBtn.classList.remove('btn-secondary', 'btn-sucess', 'btn-danger');
            this.modalBtn.classList.add('btn-success');
            this.modalBackdrop.classList.add('modal-backdrop', 'show');
            this.modal.style.display = 'block';
          },
          error: () => {
            this.modalTitle.textContent = 'Problema no envio do formulário!';
            this.modalText.textContent =
              'Houve algum problema no envio do formulário.';
            this.modalBtn.classList.remove('btn-secondary', 'btn-sucess', 'btn-danger');
            this.modalBtn.classList.add('btn-danger');
            this.modalBackdrop.classList.add('modal-backdrop', 'show');
            this.modal.style.display = 'block';
          },
        });
    } else {
      this.captcha = '';
      this.modalTitle.textContent = 'Problema no envio do formulário!';
      this.modalText.textContent =
        'Você precisa preencher corretamente o e-mail, descrição e confirmar que não é um robô!';
      this.modalBtn.classList.remove('btn-secondary', 'btn-sucess', 'btn-danger');
      this.modalBtn.classList.add('btn-danger');
      this.modalBackdrop.classList.add('modal-backdrop', 'show');
      this.modal.style.display = 'block';
    }
  }

  closeModal() {
    this.modalBackdrop.classList.remove('modal-backdrop');
    this.modalBackdrop.classList.remove('show');
    this.modal.style.display = 'none';
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
  }

  public copyForClipboard(event: MouseEvent, element): void {
    event.preventDefault();
    const payload: string = element.textContent?.trim() || '';

    const listener = (e: ClipboardEvent) => {
      const clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', payload.toString());
      e.preventDefault();
    };

    document.addEventListener('copy', listener, false);
    document.execCommand('copy');
    document.removeEventListener('copy', listener, false);
  }
}
